import React from 'react'
import styles from './Welcome.module.scss'
import { WaveContainer } from 'components/quiz/WaveContainer/WaveContainer'
import QuestionIcon from 'assets/icons/question.svg'
import ClockIcon from 'assets/icons/clock.svg'
import { MailHint } from 'components/quiz/Quiz/Quiz'
import { t } from 'ttag'

type WelcomeProps = {
  description?: React.ReactNode
  totalQuestions?: number
  time?: React.ReactNode
  button?: React.ReactNode
}

export const Welcome = ({
  description,
  totalQuestions,
  time,
  button,
}: WelcomeProps) => (
  <WaveContainer rollUp>
    <div className={styles.welcome}>
      <div className={styles.title}>{t`Before you start`}...</div>
      {description}
      <div className={styles.stats}>
        <div className={styles.stat}>
          <img src={QuestionIcon} /> {totalQuestions} {t`questions`}
        </div>
        <div className={styles.stat}>
          <img src={ClockIcon} />
          {time}
        </div>
      </div>
      {button}
    </div>
    <MailHint />
  </WaveContainer>
)
